import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=104cc62d&scoped=true"
import script from "./Paginator.vue?vue&type=script&setup=true&lang=ts"
export * from "./Paginator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=104cc62d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104cc62d",
  null
  
)

export default component.exports